module.exports = __webpack_public_path__ + "img/icon-radio-on.17c58f72.svg";